import React, { useState } from 'react'
import { ButtonWithIcon, ButtonWithoutIcon, InputBoxWraper, AuthStepsHeading, AuthStepsParagraph } from '../../../constents/components'
import { PROFILE_CV_WHILE_SIGNUP_LABEL_ID } from '../../../constents/htmlids'
import arrowIcon from '../../../Assets/arrow_back.svg';
import useCvUploader from '../../../Hooks/Registration/useCvUploader';
import { MAX_PROFILE_RESUME_SIZE } from '../../../constents/numbers';
import uploadIconDark from '../../../Assets/svgs/uploadIconDark.svg';
import useCreateProfile from '../../../Hooks/Registration/useCreateProfile';
import close from '../../../Assets/close_Icon.svg'
import IntrestEdit from '../../Profile/IntrestUpdate';



const CvStep = ({ updateFunctions, sendToNextStep, details }) => {

  const { updateInterest, updateJobIndustry } = updateFunctions;
  const [interest, setInterest] = useState([]);
  const [value, setValue] = useState('');
  const [load, err, isUserProfileCreated] = useCreateProfile()

  const valueChangeHandler = (e) => {
    if (e.key === "Enter") {
      const text = e.target.value;
      if (text.length > 0 && details.preffered_job_types.length < 5 && !details.preffered_job_types.includes(text)) {
        updateInterest([...details.preffered_job_types, e.target.value]);
        setValue("");
      }

    }
  }
  const remover = (index) => {
    const list = details.preffered_job_types.filter(item => item !== details.preffered_job_types[index])
    updateInterest(list);
  };




  const { updateCv, updateLinkedin } = updateFunctions;
  const [linkedin, setLinkedin] = useState('');
  const [cv, setCv] = useState('');
  const [cvError, SetCvError] = useState('');

  const [loading, error, isFileUploaded, cvUploader] = useCvUploader();

  const nextStepHandler = () => {
    if (cv) {
      sendToNextStep()
    }
    else {
      SetCvError('CV is Required')
    }
  }

  const cvChangeHandler = (e) => {
    SetCvError('');
    setCv(e.target.files[0]);
    cvUploader(e.target.files[0])
  }
  return (
    <div className='flex gap-4 flex-col w-full items-center'>
      {/* Intrest Setup */}
      <div className=' w-full'>

        <h2 className='font-semibold text-black mb-1'>Select your Areas of Interest</h2>

        <IntrestEdit
          values={details.preffered_job_types}
          updateJobIndustry={(text) => updateJobIndustry(text)}
          updateIntrest={(list) => updateInterest(list)}
        />
      </div>

      <div className=' w-full'>
        <h2 className='font-semibold text-black mb-1'>Profile Details</h2>
        <div className=' w-full border-[0.08rem] border-dashed border-primary-color-900 '>
          {!loading && !isFileUploaded && (<>
            <label
              className=' cursor-pointer w-full flex items-center justify-center gap-2 min-h-36 font-semibold'
              htmlFor={PROFILE_CV_WHILE_SIGNUP_LABEL_ID}>
              <div className=' w-8 aspect-square flex items-center justify-center bg-pills-bg-color-900 rounded-full'>
                <img src={uploadIconDark} className='w-4' alt="uploadIcon" />
              </div>
              Upload Your CV
            </label>
            <input
              className=' hidden'
              id={PROFILE_CV_WHILE_SIGNUP_LABEL_ID}
              type="file"
              onChange={(e) => { cvChangeHandler(e) }}
              accept=".pdf"
            />
          </>)}
        </div>
        {loading && 'uploading...'}
        {isFileUploaded && 'File Uploaded Successfully'}
        {cvError && (<p className='mt-[0.16rem] text-red-500 text-[0.725rem] leading-4'>{cvError}</p>)}
      </div>
      <div className=' w-full'>
        <p className='font-semibold text-black mb-1'>A bit more about your professional life..</p>
        <InputBoxWraper classnames={"w-full"}>
          <input
            className=' bg-transparent w-full outline-none border-none'
            type="text"
            placeholder='Enter your Linkedin URL'
            value={details.handles?.linkedin}
            onChange={(e) => updateLinkedin(e.target.value)}
          />
        </InputBoxWraper>
        {error && (<p className='t-[0.16rem] text-red-500 text-[0.725rem] leading-4'>{error}</p>)}
      </div>
      <ButtonWithIcon onButtonClick={nextStepHandler} text={"Continue"} iconClassnames={"rotate-180 h-4"} classNames={"py-4 text-white w-full"} />
      {/* <p className=' text-text-color-strong font-semibold cursor-pointer items-center' onClick={()=>sendToNextStep()}>Do it Later</p> */}
    </div>
  )
}

export default CvStep;